import PcLeftPseudoBox from './PcLeftPseudoBox';
import PcRightPseudoBox from './PcRightPseudoBox';

export const LeftPseudo = PcLeftPseudoBox;
export const RightPseudo = PcRightPseudoBox;
